module.exports = __webpack_public_path__ + "img/AdobeStock_487965398_1.833b0cff.gif";